import classNames from 'classnames/bind';
import { Modal, ModalFuncContext, ModalPosition } from 'contexts/modalFunc';
import { useDeleteHistory } from 'hooks/useHistory';
import { useRouter } from 'next/router';
import { useContext, useState } from 'react';
import {
  GroupedSearchHistory,
  SEARCH_HISTORY_COUNT,
  generateRedirectUrlFromHistory,
} from '.';
import Route from './Route';
import ScheduleInfo from './ScheduleInfo';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  history: GroupedSearchHistory;
  index: number;
}

const SubSchedule = ({ history, index }: IProps) => {
  const router = useRouter();
  const { histories } = history;
  const setModal = useContext(ModalFuncContext);
  const [isEvent, setIsEvent] = useState(false);
  const deleteHistory = useDeleteHistory(SEARCH_HISTORY_COUNT);
  const [isOptionExpanded, setIsOptionExpanded] = useState(false);
  const searchFlight = () => {
    setModal({ type: Modal.NULL, position: ModalPosition.MAIN });
    router.push(generateRedirectUrlFromHistory(histories[0]));
  };

  return (
    <li className={cx('list_item', isOptionExpanded && 'is_expanded')}>
      <a
        className={cx('anchor')}
        data-event-nlog="click"
        data-event-area-code={`arr.recentsearch${index + 1}`}
        onClick={searchFlight}
      >
        <b className={cx('route')}>
          <Route history={history} setIsEvent={setIsEvent} />
          {isEvent && <i className={cx('event')}>이벤트</i>}
        </b>
        <div className={cx('etc_area')}>
          <time className={cx('time')}>
            <ScheduleInfo history={histories[0]} />
          </time>
        </div>
      </a>
      <button
        type="button"
        className={cx('btn_remove', {
          has_one_schedule: histories?.length === 1,
        })}
        aria-label="삭제"
        data-event-nlog="click"
        data-event-area-code={`arr.recentsearch${index + 1}delete`}
        onClick={async () => {
          await deleteHistory(histories[0]?.historyId);
        }}
      />
      {histories?.length > 1 && (
        <button
          type="button"
          className={cx('btn_more')}
          aria-label="펼쳐보기"
          aria-expanded={isOptionExpanded}
          data-event-nlog="click"
          data-event-area-code={`arr.recentsearch${index + 1}more`}
          onClick={() => setIsOptionExpanded(prev => !prev)}
        />
      )}
      {isOptionExpanded && (
        <ul className={cx('option_list')}>
          {histories.map((history, index) => (
            <li className={cx('option_item')} key={index}>
              <a
                className={cx('sub_click')}
                data-event-nlog="click"
                data-event-area-code={`arr.recentsearch${index + 1}select`}
                onClick={() => {
                  router.push(generateRedirectUrlFromHistory(history));
                }}
              >
                <span className={cx('txt')}>
                  <ScheduleInfo history={history} />
                </span>
              </a>
              <button
                type="button"
                className={cx('btn_remove_option')}
                onClick={async () => {
                  await deleteHistory(history.historyId);
                }}
              />
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default SubSchedule;
